// returns user access token from localStorage if present
export const getAccessToken = () => {
    const token = localStorage.getItem('accessToken');
    return token || null;
};

// clears user access token from localStorage
export const clearAccessToken = () => {
    localStorage.removeItem('accessToken');
};

export const isSuccess = (res) => res?.status === 200 || res?.statusText === 'OK';
